import React from "react";

import FormatUtils from "../utils/formatUtils";

type StatusBadgeProps = {
  isExpired: boolean;
  status: string;
  children: React.ReactNode;
};

export default function StatusBadge({
  isExpired,
  status,
  children,
}: StatusBadgeProps) {
  const { statusBg, fontColor } = FormatUtils.getStatusStyle(status, isExpired);

  return (
    <span
      className="policy-status"
      style={{ backgroundColor: statusBg, color: fontColor }}
    >
      {children || status}
    </span>
  );
}

export function SurplusBadge() {
  return <span className="surplus-status">Surplus Lines</span>;
}
